import angular from 'angular';
import lastDayAlertComponent from './lastDayAlert.component';

let lastDayAlertModule = angular.module('lastDayAlert', [

])

.component('lastDayAlert', lastDayAlertComponent)

.name;

export default lastDayAlertModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/lastDayAlert/lastDayAlert.js